<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <!-- <img class="b-r-10" src="@/assets/images/dashboard/profile.png" alt="" /> -->
      <img class="b-r-10" :src="user?.avatar || require('@/assets/images/user/user.png')" alt="user" />
      <div class="media-body">
        <span>{{ userFullName }}</span>
        <p class="mb-0 font-roboto">
          {{ userRole }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li @click="goToAccount">
        <vue-feather type="user"></vue-feather><span>Mi cuenta</span>
      </li>
      <li>
        <vue-feather type="settings"></vue-feather><span>Configuración</span>
      </li>
      <li @click.prevent="logout">
        
        <vue-feather type="log-in"></vue-feather><span>Salir</span>
      </li>
    </ul>
  </li>
</template>

<script>
import api from '@/axios';
import authService from '@/services/authService';

export default {
  name: 'Profile',
  data() {
    return {
      user: null,
      loading: false,
      error: null,
    };
  },
  computed: {
    userFullName() {
      if (!this.user) return 'Usuario';
      const firstName = this.user.first_name || '';
      const lastName = this.user.last_name || '';
      return firstName && lastName ? `${firstName} ${lastName}` : this.user.username || 'Usuario';
    },
    userRole() {
      if (!this.user) return 'Usuario';
      if (this.user.is_superuser) return 'Super Admin';
      if (this.user.is_staff) return 'Staff';
      if (this.user.groups && this.user.groups.length > 0) {
        return this.user.groups[0];
      }
      return 'Usuario';
    }
  },
  async created() {
    await this.fetchUserData();
  },
  methods: {
    /**
     * Obtener datos del usuario desde el endpoint /me/
     */
    async fetchUserData() {
      // Verificar si hay sesión activa
      if (!authService.isAuthenticated()) {
        this.$router.push('/auth/login');
        return;
      }

      this.loading = true;
      try {
        const response = await api.get('me');
        
        if (response.data) {
          this.user = response.data;
          // Guardar datos del usuario en sessionStorage de forma segura
          authService.setUserData(response.data);
          console.log('User data loaded:', this.user);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        this.error = 'No se pudieron cargar los datos del usuario';
        
        // Si el error es de autenticación, el interceptor ya manejará el logout
        if (error.response && error.response.status === 401) {
          // El interceptor redirigirá al login
          return;
        }
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * Navegar a la página de Mi cuenta
     */
    goToAccount() {
      this.$router.push('/app/generales/micuenta');
    },
    
    /**
     * Cerrar sesión
     */
    logout() {
      this.$router.push('/auth/logout');
    }
  },
};
</script>
